<template>
    <div class="resumeCard">
        <div class="resumeCard-row">
            <p class="resumeCard-title">{{ cardTitle }}</p>
            <router-link class="resumeCard-action" :to="{ name: route }" @click.native="scrollToTop">{{ btnText }}</router-link>
        </div>
        <div class="resumeCard-row">
            <div class="resumeCard-content">
                <img v-show="colorImg != undefined" :src="colorImg" alt="">
                <p>{{ colorDesignation }}</p>
            </div>
            <p v-if="!rejectKeysArr.includes(cardKey)" class="resumeCard-price">{{ price | format_thousands }} {{ showIvaLabel }}</p>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ResumeCard',
        props:{
            cardKey: { type: [String, Number] },
            cardTitle: { type: String },
            btnText: { type: String, default: 'Alterar' },
            colorImg: { type: String },
            colorDesignation: { type: String },
            price: { type: [String, Number] },
            route: { type: String },
        },
        data(){return{
            rejectKeysArr: ['motor', 'version'],
        }},
        computed: {
            showIvaLabel(){
                return (!this.rejectKeysArr.includes(this.cardKey) && this.price != 0 ) ? '€ + IVA' : '€'
            }
        },
        methods: { 
            scrollToTop() {
                window.scrollTo(0,0);
            },
            openModal(){
                let temp = 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Enim officia obcaecati delectus et, soluta excepturi.' ;
                this.$store.commit('modalData/UPDATE_MODALSTATE', {
                    openModal: true,
                    component: 'DefaultModalContent',
                    content: temp,
                });
                document.body.classList.add('isActive')
            }
        }
    }
</script>
<style lang="scss">
    @import './ResumeCard.scss';
</style>